import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Invite Facilitator", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Recipient Information", -1)
const _hoisted_3 = { class: "grid p-fluid align-items-center" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "First Name", -1)
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Last Name", -1)
const _hoisted_10 = { class: "grid p-fluid align-items-center" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Organization", -1)
const _hoisted_14 = { class: "grid p-fluid align-items-center" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Email Address", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "License Information", -1)
const _hoisted_19 = { class: "grid p-fluid align-items-center" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "License", -1)
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "dateExpired" }, "Expiration Date", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", null, "Invoice", -1)
const _hoisted_27 = { class: "grid p-fluid align-items-center" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "field" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Send Invoices", -1)
const _hoisted_31 = {
  key: 0,
  class: "col-6"
}
const _hoisted_32 = { class: "field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "text" }, "Invoice Email Address", -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" A facilitator created this way will have an active license before payment is collected. ")
const _hoisted_35 = { class: "form-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      class: "form",
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              id: "firstName",
              type: "text",
              modelValue: _ctx.details.firstName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.details.firstName) = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "lastName",
              type: "text",
              modelValue: _ctx.details.lastName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.details.lastName) = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_InputText, {
              id: "organization",
              type: "text",
              modelValue: _ctx.details.organization,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.details.organization) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_InputText, {
              id: "recipientEmail",
              type: "email",
              modelValue: _ctx.details.recipientEmail,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.details.recipientEmail) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedLicense,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedLicense) = $event)),
                _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateLicense($event)))
              ],
              options: _ctx.licenses,
              optionLabel: "title",
              placeholder: "Select a License",
              required: true
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_Calendar, {
              id: "dateExpired",
              modelValue: _ctx.details.dateExpired,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.details.dateExpired) = $event)),
              "min-date": _ctx.defaultDate,
              required: false
            }, null, 8, ["modelValue", "min-date"])
          ])
        ])
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.invoiceMode,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.invoiceMode) = $event)),
                _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateInvoicing($event)))
              ],
              options: _ctx.invoiceModeOptions,
              optionLabel: "label",
              optionValue: "value",
              required: true
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        (_ctx.invoiceMode === _ctx.InvoiceMode.Custom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_InputText, {
                  id: "invoiceEmail",
                  type: "email",
                  required: true,
                  modelValue: _ctx.details.invoiceEmail,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.details.invoiceEmail) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Message, { severity: "warn" }, {
        default: _withCtx(() => [
          _hoisted_34
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_Button, {
          label: "Submit",
          type: "submit"
        })
      ])
    ], 32)
  ], 64))
}